export default {
  对外显示: 'External display',
  推荐的产品: 'Recommended Products',
  推荐内容修改: 'Recommended Content Modification',
  我的名片提示7: 'Data within groups can also be viewed in the "All" group',
  我的名片提示6: 'Whether to delete the current group？',
  我的名片提示5: 'Create a personal cloud exhibition, negotiate faster',
  微信扫一扫预览: 'WeChat sweep preview',
  得分: 'Score',
  立即创建: 'Create Now',
  更多样式选择: 'More Variety Options',
  请前往: 'Please go to',
  我的名片: 'My Cloud Exhibition System',
  取消编辑: 'Cancel edit',
  移动到分组: 'Move to group',
  删除分组: 'Delete group',
  编辑分组: 'Edit group',
  添加分组: 'Add group',
  最多输入100个字符: 'Enter up to 100 characters',
  '请输入个人标签,回车确定': 'Please enter a personal label, press Enter to confirm',
  最多输入30个字符: 'Enter up to 30 characters',
  '请输入邮箱,回车确定': 'Please enter your email, press Enter to confirm',
  固定电话不能为空: 'Fixed phone cannot be empty',
  我的名片提示4: 'Please enter your mobile phone number, press Enter to confirm',
  手机号格式错误: 'Malformed phone number',
  手机号不能为空: 'Phone number cannot be empty',
  职位不能为空: 'Position cannot be empty',
  职位: 'post',
  最多输入20个字符: 'Enter up to 20 characters',
  头像: 'Avatar',
  我的名片提示3: '1. The recommended size is 1:1, no more than 500kb',
  关闭: 'close',
  推荐内容: 'Recommended content',
  请完善名片: 'Please complete the business card',
  请编辑您的个人简介: 'Please edit your profile',
  我的名片提示2: 'Empty, go and add a business card',
  个人云展预览: 'Preview',
  管理员名片: 'Admin Business Card',
  我的名片提示1:
    'The corporate membership package requires the business owner account to be activated, and the sub-account is not authorized to activate! Please contact your enterprise administrator for renewal or upgrade. Your enterprise administrator is',
  续费: 'Renew',
  未认证: 'not certified',
  有效期至: 'Valid until',
  个人云展预览效果: 'Preview',
  你的名片已被禁用: 'Your business card has been deactivated.',
  原因: 'Reasons',
  参观商我的名片提示建议1: 'Currently, your company page is empty by default. To edit your company page, please click ',
  点击申请: 'Verify Now',
  '参观商我的名片提示建议1-1':
    'to apply for a business account and complete your company profile first, after which you can create multiple employee accounts to approach more quality buyers!',
  名片夹: 'Business Card Binder',
  名片: 'Business Card',
  '请输入公司名/姓名': 'Please enter company name/name.',
  // Ta转发了您的名片 1 次
  Ta转发了您的名片: 'He/She has shared your business card',
  // Ta查看了您的名片 1 次
  Ta查看了您的名片: 'He/She has viewed your business card',
  '联系方式（二选一）': 'Contact Info (Select Either Option)',
  修改名片: 'Edit Business Card',
  姓名: 'Name',
  手机号: 'Cellphone',
  固定电话: 'Fixed Phone Number',
  个人简介: 'Self-Introduction',
  个人标签: 'Personal Tag',
  联系人姓名不能为空: 'Please fill out this field',
  最多填写20位数字: 'Character limit: 20 numbers.',
  分享二维码让客户扫一扫获取您的名片: 'Share the QR Code of Your Business Card',
  暂无名片夹数据: 'No business card yet.',
  '请填写,最多500字符,若需要换行,请直接回车键输入': 'Character limit: 1000. Press Enter key to start a new line.',
  '请填写,每个标签最多15个字符,最多20个标签,回车键确定':
    'Press Enter key to add new tags. You can add 20 tags at most, each within 30 characters.',
  形象照片: 'Profile Picture',
  添加推荐: 'Recommendation Settings',
  我的推荐内容: 'My Recommend',
  推荐内容类型: 'Category',
  暂无设置推荐内容: 'No recommended content',
  暂无填写个人简介: 'No profile yet',
  暂无填写个人名片: 'No card yet',
  预览名片: 'Preview Business Card',
  分享云展: 'Share Card',
  预览效果: 'Preview',
  选择推荐内容类型: 'Select Category',
  修改个人简介: 'Edit Self-Introduction',
  确定: 'Submit',
}
